import React from "react";
import { Flex } from "@jsq/ds/core";

type FormSelectFlexProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * A component that represents a row in an input form.
 *
 * @component
 * @example
 * ```tsx
 * <SimpleFormRow>
 *   <input type="text" />
 *   <button>Submit</button>
 * </SimpleFormRow>
 * ```
 */
export const SimpleFormRow: React.FC<FormSelectFlexProps> = ({
  children,
  className = "stacked-lg",
}) => {
  return <Flex className={className}>{children}</Flex>;
};
